import { ExportHeaderMetadata } from "../../lib/utils/export-utils";

export const createDebitorenHeaderTemplate = (headerMetadata: ExportHeaderMetadata) => {
	return ({ pageNum, totalPages }: { element: HTMLElement; pageNum: number; totalPages: number }) => {
		const filterParts: string[] = [];
		if (headerMetadata.recipientFilter) {
			filterParts.push(`Empfänger: ${headerMetadata.recipientFilter}`);
		}
		if (headerMetadata.globalFilter) {
			filterParts.push(`Suche: "${headerMetadata.globalFilter}"`);
		}

		let dateText = '';
		if (headerMetadata.dateRange) {
			dateText = `Zeitraum: ${headerMetadata.dateRange.start} - ${headerMetadata.dateRange.end}`;
		} else if (headerMetadata.singleDate) {
			dateText = `Stichtag: ${headerMetadata.singleDate}`;
		}

		const headerHtml = `
			<div style="
				position: absolute;
				top: 5mm;
				left: 10mm;
				right: 10mm;
				height: 18mm;
				font-family: LiberationSans, sans-serif;
				font-size: 9pt;
				font-weight: 400;
				z-index: 1000;
				border-bottom: 1px solid #ccc;
				padding-bottom: 2mm;
			">
				<div style="display: flex; justify-content: space-between; align-items: flex-start;">
					<div style="font-size: 12pt; font-weight: bold;">${headerMetadata.exportTypeLabel}</div>
					<div style="font-size: 9pt; color: #666;">Seite ${pageNum} von ${totalPages}</div>
				</div>
				<div style="margin-top: 1mm; color: #333;">Exportdatum: ${headerMetadata.exportDate}${dateText ? ` | ${dateText}` : ''}</div>
				${filterParts.length > 0 ? `<div style="margin-top: 1mm; color: #333;">Filter: ${filterParts.join(' | ')}</div>` : ''}
				${headerMetadata.sorting ? `<div style="margin-top: 1mm; color: #333;">Sortierung: ${headerMetadata.sorting}</div>` : ''}
			</div>
		`;

		return headerHtml;
	};
};
